import PropTypes from "prop-types";
// form
import { useFormContext, Controller } from "react-hook-form";
// @mui
import { Autocomplete, TextField } from "@mui/material";

// ----------------------------------------------------------------------

RHFAutocomplete.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string,
};

export default function RHFAutocomplete({
  name,
  children,
  option,
  placeholder,
  multiple,
  label,
  size = "small",
  onInputChange,
  required,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          multiple={multiple}
          value={multiple ? (field.value || []) : (field.value || null)}
          onChange={(_, value) => {
            field.onChange(value);
            if (onInputChange) {
              onInputChange(value);
            }
          }}
          options={option || []}
          fullWidth
          {...other}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={placeholder || "Search here..."}
              size={size}
              label={label}
              required={required}
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      )}
    />
  );
}
